import { render, staticRenderFns } from "./ShippedIcon.vue?vue&type=template&id=6b7b941f"
import script from "./ShippedIcon.vue?vue&type=script&lang=js"
export * from "./ShippedIcon.vue?vue&type=script&lang=js"
import style0 from "./ShippedIcon.vue?vue&type=style&index=0&id=6b7b941f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports